import * as React from 'react';

const Heart24 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 24 24", width: 24, height: 24, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M3.365 6.274C4.39 4.839 6.017 4.189 7.758 4.639c1.481.383 2.865 1.54 3.555 2.882.277.54 1.095.54 1.372 0 .69-1.342 2.074-2.5 3.556-2.882 1.741-.45 3.368.2 4.394 1.634 2.04 2.854.085 6.26-2.247 8.334l-.002.001-5.558 4.578c-.478.42-1.198.42-1.676-.001l-5.538-4.577-.001-.001c-2.333-2.074-4.288-5.48-2.248-8.333m8.634-.474C11.05 4.567 9.66 3.58 8.14 3.188c-2.343-.605-4.627.281-6.012 2.22-2.511 3.514-.45 7.717 2.474 10.316l.002.002 5.54 4.58a2.8 2.8 0 0 0 3.69.002l5.56-4.581.004-.003c2.924-2.599 4.985-6.803 2.474-10.316-1.386-1.94-3.67-2.825-6.014-2.22-1.518.393-2.91 1.38-3.859 2.612"
  }
));
Heart24.Size = 24;
Heart24.Title = "Heart";

export { Heart24 as default };
